<template>
  <el-row class="container" @click.native="hideMenu">
    <aside v-if="isOpenMenu">
      <sidebar />
    </aside>
    <div class="main">
      <div class="top">
        <div class="menu-button">
          <el-button icon="el-icon-menu" @click.stop="showMenu">{{
            $t("menu")
          }}</el-button>
        </div>
        <navbar />
      </div>
      <Breadcrumb v-if="!this.$route.meta.hideBreadcrumb" />
      <div
        class="content"
        :style="{ top: this.$route.meta.hideBreadcrumb ? '80px' : '175px' }"
      >
        <router-view />
      </div>
    </div>
  </el-row>
</template>

<script>
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  data() {
    return { isOpenMenu: true };
  },
  methods: {
    hideMenu: function () {
      if (this.isMobile()) {
        this.isOpenMenu = false;
      }
    },
    showMenu: function (e) {
      this.isOpenMenu = !this.isOpenMenu;
    },
  },
  created: function () {
    this.isOpenMenu = !this.isMobile();
    document.title = this.$t("dealer.dealer_management_system");
    this.api.dealer.user.status({}).then((response) => {
      if (!response.data.errorCode) {
        if (response.data.data) {
          this.$store.commit({
            type: "loginIn",
            name: response.data.data.name,
            userName: response.data.data.phone,
            id: response.data.data.id,
            token: response.data.data.token,
          });
        } else {
          this.$store.commit("logout");
        }
      }
    });
  },
  components: { Sidebar, Navbar, Breadcrumb },
};
</script>
<style scoped>
.container {
  display: flex;
  height: 100%;
}
.top{
  width: 100%;
  display: block;
  height: 80px;
  position: relative;
  overflow: hidden;
}

@media screen and (max-device-width: 960px) {
  aside {
    display: block;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 230px;
    background: #2b303b;
    height: 100%;
    z-index: 999;
  }
}
@media screen and (min-device-width: 960px) {
  aside {
    flex: 0 0 230px;
    background: #2b303b;
    position: relative;
  }
}

.menu-button {
  position: absolute;
  top: 15px;
  left: 10px;
  z-index: 990;
}

.main {
  flex: 1;
  background: #f2f4f8;
  position: relative;
}

.main .content {
  position: absolute;
  top: 175px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow-y: scroll;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// Main.vue?065e132b